// Burger King CSS

import { LayoutWidth, NAV_HEIGHT, ZIndex } from './enums';
import { primitive } from './primitives';
// Burger King 2020 Legacy Visual Identity

export default {
  // Extra CSS Properties
  borderRadius: `${primitive.$borderRadius}px`,
  boxShadow: '0px 0px 4px 0px rgba(73, 73, 73, 0.2)',
  shadowColor: 'rgba(73, 73, 73, 0.2)',
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  shadowRadius: 4,

  // Color Styles
  color: {
    accent: '#af0c2a',
    alert: {
      default: {
        background: primitive.bk.$bbqBrown,
        text: '#ffffff',
      },
      info: {
        background: '#FF8732',
        text: '#ffffff',
      },
      success: {
        background: '#1B8737',
        text: '#ffffff',
      },
      warning: {
        background: primitive.bk.$fieryRed,
        text: '#ffffff',
      },
      error: {
        background: primitive.bk.$fieryRed,
        text: '#ffffff',
      },
    },
    codeBlockBackground: primitive.bk.$mayoEggWhite,
    contrastBackground: primitive.bk.$bbqBrown,
    error: primitive.bk.$fieryRed,
    errorHover: '',
    pricing: primitive.bk.$bbqBrown,
    validated: '#1b8737',
    validatedHover: '',
    primary: primitive.bk.$fieryRed,
    primaryHover: '#a71b00',
    secondary: primitive.bk.$fieryRed,
    secondaryHover: '#a71b00',
    teal: '',
    tertiary: primitive.bk.$bbqBrown,
    background: primitive.bk.$mayoEggWhite,
    loyaltyHighlight: '',
    navLinkColor: {
      active: primitive.bk.$fieryRed,
      hover: '#a71b00',
    },
    mobileNavButtonColor: primitive.bk.$bbqBrown,
    black: primitive.bk.$bbqBrown,
    icon: primitive.bk.$fieryRed,
    grey: {
      one: '#2b0200',
      two: '#9f816f',
      three: '#693f34',
      four: '#bba391',
      five: '#d7c7b5',
      six: '#845f50',
      seven: '#340000',
      eight: '#4e201d',
      nine: 'rgba(0, 0, 0, 0.04)',
      ten: 'rgba(0, 0, 0, 0.1)',
      eleven: '#F5F5F5',
    },
    headerContrast: primitive.bk.$fieryRed,
    highlight: '',
    white: primitive.bk.$mayoEggWhite,
    cardBackground: '#fff',
    disabledBorder: '#d4c7b7',
    disabledBackground: '',
    disabledColor: '#d4c7b7',
    success: '',
    red: primitive.bk.$fieryRed,
    orange: '#fe8731',
  },

  // Font Styles
  fontFamily: {
    base: 'heading',
    body: 'body',
    alternative: 'alternative',
    brand: 'heading',
  },

  // Font Weight Styles
  fontWeight: {
    black: 700,
    heavy: 700,
    normal: 400,
    light: 400,
  },

  // Font Transforms Styles
  textTransform: {
    headlines: 'none',
    body: 'none',
  },

  // Z Index Styles
  zIndex: {
    max: ZIndex.MAX,
    overlay: ZIndex.OVERLAY,
    top: ZIndex.TOP,
    normal: ZIndex.NORMAL,
    below: ZIndex.BELOW,
  },

  // Layout variables
  layout: {
    sectionMaxWidth: `${LayoutWidth.REGULAR}px`,
    smallerSectionMaxWidth: `${LayoutWidth.SMALL}px`,
    checkoutHeaderHeight: '57px',
    navHeight: {
      mobile: `${NAV_HEIGHT.MOBILE}px`,
      desktop: '78px',
    },
  },
};
